var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lxn-waiting-modal lxn-w100 lxn-h100 lxn-pos-fix lxn-overflow-hidden"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"dot1"}),_c('div',{staticClass:"dot2"})])])
}]

export { render, staticRenderFns }